<div class="header">
  <div class="logo logo-dark">
    <a href="">
      <img
        src="assets/images/logo/Group 239227.png"
        alt="Logo"
        style="width: 90%; height: auto; margin: 10px"
      />
      <img
        class="logo-fold"
        src="assets/images/logo/utm-header.png"
        alt="Logo"
        style="width: 50px; height: auto; margin: 10px"
      />
    </a>
  </div>
  <div class="logo logo-white">
    <a href="">
      <img src="assets/images/logo/logo-white.png" alt="Logo" />
      <img
        class="logo-fold"
        src="assets/images/logo/logo-fold-white.png"
        alt="Logo"
      />
    </a>
  </div>
  <div class="nav-wrap" style="background-color: #bf0404">
    <ul class="nav-left">
      <li class="desktop-toggle text">
        <a (click)="toggleFold()">
          <i
            nz-icon
            [nzType]="isFolded ? 'menu-unfold' : 'menu-fold'"
            theme="outline"
            class="text-white rtl-flip"
          ></i>
        </a>
      </li>
      <li class="mobile-toggle">
        <a (click)="toggleExpand()">
          <i
            nz-icon
            [nzType]="isExpand ? 'menu-fold' : 'menu-unfold'"
            theme="outline"
            class="text-white rtl-flip"
          ></i>
        </a>
      </li>

      <ul
        *ngIf="showRoleMenus && (roleService.isEtudiants()||roleService.isEtudiant()) && !(roleService.ENSEIGNANTS()||roleService.ENSEIGNANT())"
        class="nav-left d-none d-lg-flex"
        [style.margin-left.px]="rtl ? null : 120"
        [style.margin-right.px]="rtl ? 120 : null"
      >
        <li>
          <a nz-dropdown [nzDropdownMenu]="menu1" nzTrigger="click">
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.myUniversity' | translate }}
              <i nz-icon nzType="down" class="font-size-13 m-l-5"></i>
            </span>
          </a>

          <nz-dropdown-menu #menu1="nzDropdownMenu">
            <ul nz-menu>
              <li nz-submenu [nzTitle]="'nav.myContacts' | translate">
                <ul>
                  <li nz-menu-item>{{ 'nav.studentReps' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.studentServices' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.faculties' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.ufr' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.doctoralSchools' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.equalityNetwork' | translate }}</li>
                </ul>
              </li>

              <li
                nz-submenu
                [nzTitle]="'nav.studyConditions' | translate"
              >
                <ul>
                  <li nz-menu-item>{{ 'nav.covid' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.equality' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.prevention' | translate }}</li>
                </ul>
              </li>

              <li nz-submenu [nzTitle]="'nav.afterDegree' | translate">
                <ul>
                  <li nz-menu-item>{{ 'nav.alumni' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.continuingEd' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.careerSupport' | translate }}</li>
                </ul>
              </li>

              <li nz-submenu [nzTitle]="'nav.elections' | translate">
                <ul>
                  <li nz-menu-item routerLink="#">{{ 'nav.atUniversity' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.crous' | translate }}</li>
                </ul>
              </li>
            </ul>
          </nz-dropdown-menu>
        </li>

        <li>
          <a nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.mySchooling' | translate }}
              <i nz-icon nzType="down" class="font-size-13 m-l-5"></i>
            </span>
          </a>

          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-submenu [nzTitle]="'nav.myStudies' | translate">
                <ul>
                  <li nz-menu-item>{{ 'nav.calendar' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.transversal' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.certifications' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.libraries' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.abroad' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.disability' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.reorientation' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.adjustStudies' | translate }}</li>
                </ul>
              </li>

              <li nz-submenu [nzTitle]="'nav.myProcedures' | translate">
                <ul>
                  <li nz-menu-item>{{ 'nav.reenroll' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.cancelEnrollment' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.transferFile' | translate }}</li>
                  <li nz-menu-item>
                    {{ 'nav.studentCard' | translate }}
                  </li>
                  <li nz-menu-item>
                    {{ 'nav.refund' | translate }}
                  </li>
                  <li nz-menu-item>
                    {{ 'nav.exemption' | translate }}
                  </li>
                  <li nz-menu-item>{{ 'nav.changeContact' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.changeName' | translate }}</li>
                  <li nz-menu-item>
                    {{ 'nav.transcript' | translate }}
                  </li>
                  <li nz-menu-item>
                    {{ 'nav.diploma' | translate }}
                  </li>
                </ul>
              </li>

              <li nz-submenu [nzTitle]="'nav.proLife' | translate">
                <ul>
                  <li nz-menu-item>{{ 'nav.internship' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.workStudy' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.entrepreneurship' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.doctoralContract' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.studentContract' | translate }}</li>
                  <li nz-menu-item>{{ 'nav.cifre' | translate }}</li>
                </ul>
              </li>

              <li nz-submenu [nzTitle]="'nav.personalData' | translate">
                <ul>
                  <li nz-menu-item routerLink="#">{{ 'nav.dataProcessing' | translate }}</li>
                </ul>
              </li>
            </ul>
          </nz-dropdown-menu>
        </li>

        <li>
          <a>
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.studentLife' | translate }}
            </span>
          </a>
        </li>
        <li>
          <a
            nz-dropdown
            [nzDropdownMenu]="DemanderAssistance"
            nzTrigger="click"
          >
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.toolbox' | translate }}
              <i nz-icon nzType="down" class="font-size-13 m-l-5"></i>
            </span>
          </a>

          <nz-dropdown-menu #DemanderAssistance="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item routerLink="#"></li>
            </ul>
          </nz-dropdown-menu>
        </li>
      </ul>

      <ul
        *ngIf="showRoleMenus && (roleService.ENSEIGNANTS()||roleService.ENSEIGNANT())"
        class="nav-left d-none d-lg-flex"
        [style.margin-left.px]="rtl ? null : 50"
        [style.margin-right.px]="rtl ? 50 : null"
      >
        <li>
          <a nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.daily' | translate }}

              <i nz-icon nzType="down" class="font-size-13 m-l-5"></i>
            </span>
          </a>
        </li>

        <li>
          <a>
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.workLife' | translate }}
            </span>
          </a>
        </li>
        <li>
          <a>
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.careers' | translate }}
            </span>
          </a>
        </li>
        <li>
          <a
            nz-dropdown
            [nzDropdownMenu]="DemanderAssistance"
            nzTrigger="click"
          >
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.teachingSupport' | translate }}

              <i nz-icon nzType="down" class="font-size-13 m-l-5"></i>
            </span>
          </a>

          <nz-dropdown-menu #DemanderAssistance="nzDropdownMenu">
            <ul nz-menu></ul>
          </nz-dropdown-menu>
        </li>
        <li>
          <a>
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.researchSupport' | translate }}
            </span>
          </a>
        </li>

        <li>
          <a nz-dropdown [nzDropdownMenu]="Maviepro" nzTrigger="click">
            <span class="text-white d-flex align-items-center font-size-13">
              {{ 'nav.organisation' | translate }}

              <i nz-icon nzType="down" class="font-size-13 m-l-5"></i>
            </span>
          </a>
        </li>
      </ul>
    </ul>
    <ul class="nav-right">
      <!-- -i18n- FR | EN -->
      <li class="d-flex align-items-center">
        <app-lang-switch [light]="true"></app-lang-switch>
      </li>
      <!-- -chat- icônes "Aide" et "Meet" masquées pour l'instant (à remettre : dé-commenter)
      <li>
        <a>
          <nz-badge>
            <i nz-icon nzType="question-circle" theme="outline" class="text-white"></i>
          </nz-badge>
        </a>
      </li>
      <li>
        <a href="https://meet.google.com/landing" target="_blank">
          <nz-badge>
            <i nz-icon nzType="video-camera" theme="outline" class="text-white"></i>
          </nz-badge>
        </a>
      </li>
      -->
      <li>
        <!-- -chat- nombre de messages non lus -->
        <a (click)="openChat()" [title]="'menu.chat' | translate" style="cursor: pointer">
          <nz-badge [nzCount]="unreadMessages" nzSize="small">
            <i nz-icon nzType="message" theme="outline" class="text-white"></i>
          </nz-badge>
        </a>
      </li>
      <li>
        <a
          nz-dropdown
          nzTrigger="click"
          [nzDropdownMenu]="popNotification"
          [nzPlacement]="rtl ? 'bottomLeft' : 'bottomRight'"
          [(nzVisible)]="notifOpen"
        >
          <nz-badge [nzCount]="unreadNotifications" nzSize="small">
            <i nz-icon nzType="bell" theme="outline" class="text-white"></i>
          </nz-badge>
        </a>
        <!-- -chat fixes- cloche compacte : icone, titre, apercu sur une ligne, date, point rouge si non lue ; une seule barre de defilement -->
        <nz-dropdown-menu #popNotification="nzDropdownMenu">
          <div nz-menu class="pop-notification pn">
            <div class="pn-head">
              <span class="pn-title">{{ 'notif.pageTitle' | translate }}</span>
              <span class="pn-count" *ngIf="unreadNotifications">{{ 'notif.unreadCount' | translate: { n: unreadNotifications } }}</span>
              <span class="pn-spacer"></span>
              <a class="pn-link" *ngIf="unreadNotifications" (click)="markAllRead()">{{ 'notif.markAllRead' | translate }}</a>
            </div>
            <div class="pn-list">
              <a class="pn-item" *ngFor="let item of projectListRaw" [class.unread]="!item.read" (click)="openNotification(item)">
                <span class="pn-icon" [class.chat]="isChat(item)">
                  <i nz-icon [nzType]="isChat(item) ? 'message' : 'bell'" nzTheme="outline"></i>
                </span>
                <span class="pn-body">
                  <span class="pn-item-title">{{ title(item) }}</span>
                  <span class="pn-item-msg" *ngIf="item.message" [attr.dir]="rtl ? 'auto' : null">{{ item.message }}</span>
                  <span class="pn-item-date">{{ item.date | date : ('common.dateTime' | translate) }}</span>
                </span>
                <span class="pn-dot" *ngIf="!item.read"></span>
              </a>
              <p *ngIf="!projectListRaw?.length" class="pn-empty">{{ 'notif.none' | translate }}</p>
            </div>
            <a class="pn-foot" [routerLink]="'/apps/notification'" (click)="notifOpen = false">{{ 'notif.seeAllLong' | translate }}</a>
          </div>
        </nz-dropdown-menu>
      </li>
      <li>
        <span
          class="p-h-10 pointer"
          nz-dropdown
          [nzDropdownMenu]="profile"
          [nzTrigger]="'click'"
          [nzPlacement]="rtl ? 'bottomLeft' : 'bottomRight'"
        >
          <nz-avatar
            [nzIcon]="'user'"
            [nzSrc]="user?.imagePath ? 'assets/images/avatars/' + user.imagePath : null"
          ></nz-avatar>
        </span>
        <nz-dropdown-menu #profile="nzDropdownMenu">
          <ul nz-menu class="p-b-15 p-t-20">
            <li nz-menu-item>
              <a
                class="p-v-5 d-flex align-items-center justify-content-between"
                (click)="logout()"
              >
                <div>
                  <i
                    class="opacity-04 font-size-16"
                    nz-icon
                    nzType="logout"
                    theme="outline"
                  ></i>
                  <span class="m-l-10">{{ 'menu.logout' | translate }}</span>
                </div>
                <i
                  class="font-size-10 rtl-flip"
                  nz-icon
                  nzType="right"
                  theme="outline"
                ></i>
              </a>
            </li>
          </ul>
        </nz-dropdown-menu>
      </li>
      <li class="mobile-toggle" *ngIf="showRoleMenus && !roleService.isAdmin()">
        <a (click)="toggleRightSideNav()">
          <i
            nz-icon
            [nzType]="isRightSideNavOpen ? 'menu' : 'menu'"
            class="text-white"
          ></i>
        </a>
      </li>
    </ul>
  </div>
</div>
<app-right-side-nav
  [isRightSideNavOpen]="isRightSideNavOpen"
  [user]="user"
></app-right-side-nav>